export default "__VITE_ASSET__BbKzjNDI__"